// @flow strict
import * as React from 'react'
import { type PropsWithChildren } from '../../utils/typeUtils'
import styles from './Card.module.scss'

import Heading from './Heading'
import Text from './Text'
import ContentHeader from './ContentHeader'

export const BespokeCardContent = (props: PropsWithChildren<{}>) => {
  return <>{props.children}</>
}
type Props = {
  className?: string,
  children: React.ChildrenArray<
    | React.Element<typeof Heading>
    | React.Element<typeof Text>
    | React.Element<typeof ContentHeader>
    | React.Element<typeof BespokeCardContent>,
  >,
}

const Content = (props: Props) => (
  <div className={props.className ? props.className : styles.content}>
    {props.children}
  </div>
)

export default Content
